import { Controller } from '@hotwired/stimulus';
import Splide from '@splidejs/splide';

export default class extends Controller {
    connect() {
        const additionalConfig = this.element.dataset.splideConfig ? JSON.parse(this.element.dataset.splideConfig) : {};

        // Config https://splidejs.com/guides/options/
        const config = {
            lazyLoad: 'nearby',
            autoWidth: true,
            focus: 'left',
            pagination: false,
            type: 'loop',
            speed: 1000,
            autoplay: true,
            ...additionalConfig,
        };

        this.splide = new Splide(this.element, config);
        this.splide.mount();
    }
}
